import { StateCreator } from 'zustand';
import { hideSnackBarFromExternalScript } from '../../pages/home/hero/car-tile/carTileUtils';
import { getSavedVehicles } from '../../utilities/savedVehicles';
import { ITrackingPayload } from '../../types/analytics';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../utilities/analytics';
import { IAppState, IFavoriteVehiclesSlice } from './stateTypes';

const createFavoriteVehiclesSlice: StateCreator<IAppState, [], [], IFavoriteVehiclesSlice> = (set, get) => ({
    favoriteVehicles: [],
    toggleFavoritesResponse: (isSuccess: boolean, componentCallback?: () => void) => {
        if (isSuccess && typeof componentCallback === 'function') {
            componentCallback();
        }
    },
    addVehicleToFavorites: async (stockNumber: number) => {
        const payload: ITrackingPayload = {
            event: ANALYTICS_CONSTANTS.EVENTS.CLICK.SAVE_RECOMMENDED_CAR,
            linkDetails: {
                name: 'save car',
                position: stockNumber.toString(),
            },
            recommendations: {
                stockNumber: stockNumber.toString(),
            },
        };
        trackEDDL(payload);
        const event = new CustomEvent('kmxAddSavedCar', {
            bubbles: true,
            detail: {
                stockNumber,
                callback: async (result: Promise<boolean>) => {
                    const isSuccess = await result;
                    get().toggleFavoritesResponse(isSuccess, () => {
                        set((state) => ({ favoriteVehicles: [...state.favoriteVehicles, stockNumber] }));
                    });
                },
            },
        });
        document.documentElement.dispatchEvent(event);
    },
    removeVehicleFromFavorites: async (stockNumber: number, hideSnackbar?: boolean) => {
        const payload: ITrackingPayload = {
            event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
            linkDetails: {
                name: 'remove from favorites',
                position: stockNumber.toString(),
            },
            stockNumber: stockNumber.toString(),
        };
        trackEDDL(payload);
        const event = new CustomEvent('kmxRemoveSavedCar', {
            bubbles: true,
            detail: {
                stockNumber,
                callback: async (result: Promise<boolean>) => {
                    const isSuccess = await result;
                    get().toggleFavoritesResponse(isSuccess, () =>
                        set((state) => ({
                            favoriteVehicles: state.favoriteVehicles.filter(
                                (favoriteStockNumber) => favoriteStockNumber !== stockNumber,
                            ),
                        })),
                    );
                },
            },
        });

        if (hideSnackbar) hideSnackBarFromExternalScript();

        document.documentElement.dispatchEvent(event);
    },
    setFavoriteVehicles: async () => {
        getSavedVehicles((favoriteVehicles: number[]) => {
            set({ favoriteVehicles });
        });
    },
});

export default createFavoriteVehiclesSlice;
